import { render, staticRenderFns } from "./LRow.vue?vue&type=template&id=0d2f2f65"
import script from "./LRow.vue?vue&type=script&lang=js"
export * from "./LRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports